import React, { useMemo } from "react";
import { Grid } from "@material-ui/core";

import { IWithballData } from "types";
import { TouchBallBoard } from "components/TouchBallBoard";
import { filterMyValidData } from "utils";

interface IMyTouchBallPanelProps {
  dataArray: { [key: string]: IWithballData[] };
  playerId: string;
}

export const MyTouchBallPanel = ({
  dataArray,
  playerId,
}: IMyTouchBallPanelProps) => {
  const { myValidDataArray } = useMemo(() => {
    return {
      myValidDataArray: filterMyValidData(playerId, dataArray),
    };
  }, [dataArray, playerId]);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6} lg={4}>
        <TouchBallBoard dataArray={myValidDataArray} playerId={playerId} />
      </Grid>
    </Grid>
  );
};
